import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { LtClickResponse } from '../interfaces/LtClickResponse';


@Injectable({
  providedIn: 'root'
})
export class LinktrustService {

  constructor(private http: HttpClient) { }

  getRedirectUrl(cid: string, afid: string, sid: string, product: string, additionalParams: any) {
    let url = environment.api.base_url + environment.api.paths.getRedirectUrl;
    url = url + '?cid=' + cid;
    url = url + '&afid=' + afid;
    url = url + '&sid=' + sid;
    url = url + '&product=' + product;

    // fill additional parameters
    for (const name in additionalParams) {
      if (!additionalParams[name]) {
        continue;
      }
      url = url + '&' + name + '=' + additionalParams[name];
    }
    return this.http.get(url);
  }


  async generateOrganicClick(cid: string, afid: string, sid: string, additionalParams: Object): Promise<LtClickResponse> {
    var promise = new Promise<LtClickResponse>((resolve, reject) => {

      let url = environment.api.base_url + environment.api.paths.ltClick;
      this.http.post<LtClickResponse>(url, {
        afid: afid,
        cid: cid,
        sid: sid,
        additionalParams: additionalParams
      }).subscribe(res => {
        console.log('LT click fired!');
        console.log(res);
        resolve(res);
      }, err => {
        console.error('LT click not fired!');
        console.error(err);
        reject(err);
      })
    });

    return promise.then(res => res).catch(err => err);

  }
}
